import { render } from "./IconItemCategoryGiftCard.vue?vue&type=template&id=98ba672c"
import script from "./IconItemCategoryGiftCard.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryGiftCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__